module.exports = __webpack_public_path__ + "static/Grubhub-2c815923e87c977f167df46c2b0edafb.jpg";